import { defineMessages } from 'react-intl'

export default defineMessages({
  memberActivityByDeviceSectionTitle: {
    id: 'SpaceAnalyticsPage.Section.MemberActivityByDevice.Title',
    defaultMessage: 'Member Activity By Device'
  },

  memberActivityByOSTitle: {
    id: 'SpaceAnalyticsPage.Section.MemberActivityByOS.Title',
    defaultMessage: 'Member Activity By OS'
  },

  userActivityByDeviceTitle: {
    id: 'SpaceAnalyticsPage.Section.userActivityByDeviceTitle.Title',
    defaultMessage: 'User Activity By Device'
  },

  userActivityByOSTitle: {
    id: 'SpaceAnalyticsPage.Section.userActivityByOSTitle.Title',
    defaultMessage: 'User Activity By OS'
  },

  userActivityDeviceChartLabelDesktop: {
    id: 'SpaceAnalyticsPage.Section.userActivityDeviceChartLabelDesktop.Label',
    defaultMessage: 'Desktop'
  },

  userActivityDeviceChartLabelMobile: {
    id: 'SpaceAnalyticsPage.Section.userActivityDeviceChartLabelMobile.Label',
    defaultMessage: 'Mobile'
  },

  memberActivityByDeviceSectionDescription: {
    id: 'SpaceAnalyticsPage.Section.MemberActivityByDevice.Description',
    defaultMessage: 'Includes digital assistant activity by device'
  },

  memberActivityByOSDescription: {
    id: 'SpaceAnalyticsPage.Section.MemberActivityByOS.Description',
    defaultMessage: 'Includes digital assistant activity by operating system'
  }
})
